import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
export function formatContactsBirthdate(submission) {
  if (isContactsBirthdate(submission)) {
    return format(submission);
  }
  return undefined;
}
function isContactsBirthdate(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_BIRTHDATE && typeof label === 'string' && typeof value === 'string';
}
function format(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
//# sourceMappingURL=contacts-birthdate-preview.js.map